import React, {Component, Fragment} from 'react';
import { inject, observer } from 'mobx-react';
import { airForm, SelectOptions } from '../../../commonComponents';

import K from '../../../services/constants';

import { Form, DatePicker, Layout, Col, Row, Checkbox, Divider, Input, Radio, Upload, Icon, message, Button } from 'antd';
import moment from 'moment';
import { when } from 'mobx';
import {countriesHelper} from "../../../helpers";

const { Content, Footer } = Layout;

const REGEX_POSTALCODE = /^[0-9]{5}$/i;

@inject('translationsStore', 'step3RegistrationStore', 'registrationStore', 'commonStore', 'profileStore', 'countriesStore', 'provincesStore', 'citiesStore',)
@observer
class ProductSelectionTabPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethods: [],
      heartbeatStatus: 0,
      componentDidMount: false,
      hasAlreadyService: false,
      defaultFileList: [],
      additionalDevices: [],
      selectedAdditionalDevices: []
    };

    this.commonUplaodProps = {
      multiple: false,
      headers: { Authorization: `Bearer ${this.props.commonStore.token.access_token}` },
      beforeUpload: (file, fileList) => {
        const isPDF = file.type === 'application/pdf';
        const isLt2M = file.size / 1024 / 1024 <= 4;
        if (!isPDF) {
          message.error('You can only upload PDF file!');
        }
        if (!isLt2M) {
          message.error('File must be smaller than 4MB!');
        }
        !(isPDF && isLt2M) && fileList.splice(0, 1);
        return isPDF && isLt2M;
      }
    };
  }

  uploadProps = () =>
    Object.assign({}, this.commonUplaodProps, {
      action: `${K.API_URL}/api/v2/profile/identity-document/${this.props.step3RegistrationStore.user._id}`,
      defaultFileList: this.state.defaultFileList
    });

  getProductForActiveInsurancePolicy = policy => {
    const {step3RegistrationStore} = this.props
    if(!policy) {
      return null
    }

    let insurancePolicy = policy.attributes.detailed_guarantees.find(guarantee => guarantee.product_key === 'dispositivo_satellitare_premium');
    if (insurancePolicy) {
      return step3RegistrationStore.services.find(
        s =>
          s.productName.startsWith('MyGarage Premium A') &&
          s.recurring.duration == insurancePolicy.duration_in_months &&
          s.recurring.chargeModel === 'one-time'
      );
    }

    insurancePolicy = policy.attributes.detailed_guarantees.find(guarantee => guarantee.product_key === 'dispositivo_satellitare_plus');
    if (insurancePolicy) {
      return step3RegistrationStore.services.find(
          s =>
              s.productName.startsWith('MyGarage Plus A') &&
              s.recurring.duration == insurancePolicy.duration_in_months &&
              s.recurring.chargeModel === 'one-time'
      );
    }

    insurancePolicy = policy.attributes.detailed_guarantees.find(guarantee => guarantee.product_key === 'dispositivo_satellitare_light');
    if (insurancePolicy) {
      return step3RegistrationStore.services.find(
          s =>
              s.productName.startsWith('MyGarage Light A') &&
              s.recurring.duration == insurancePolicy.duration_in_months &&
              s.recurring.chargeModel === 'one-time'
      );
    }

    insurancePolicy = policy.attributes.detailed_guarantees.find(guarantee => guarantee.product_key === 'pacchetto_completo');
    if (insurancePolicy) {
      return step3RegistrationStore.services.find(
        s =>
          s.productName === 'Listino Concessionari' &&
          s.oneTime.duration == insurancePolicy.duration_in_months &&
          ((s.risk === 'low' && insurancePolicy.risk_level === 'basso') || (s.risk === 'high' && insurancePolicy.risk_level === 'alto'))
      );
    }
  }

  componentDidMount() {
    const {
      profileStore,
      step3RegistrationStore,
      step3RegistrationStore: { user }
    } = this.props;

    const { installationSignatureDate, decurringTime: startDate, zuoraOneTimeRatePlan, zuoraRecurringRatePlan } = user.assets[0].subscription;

    let policyStartDate = null;

    when(
      () => step3RegistrationStore.services && step3RegistrationStore.services.length > 0,
      () => {
        // managing initial values for additional device assets scenario
        // next code to allow initial values to be correctly timely rendered once external catalog products are loaded
        // as placed elsewhere would raise earlier timing offset than expected
        if (user.hasOwnProperty('additionalAssets')) {
          for (let i = 0; i < user.additionalAssets.length; i++) {
            this.props.form.getFieldDecorator(`additionalDevices${i}`, { initialValue: user.additionalAssets[i] })
          }
          this.setState({ selectedAdditionalDevices: user.additionalAssets.map((x, index) => ({ index, value: x })) });
        }

        if (zuoraOneTimeRatePlan) return;
        step3RegistrationStore.loadAssetServiceLevel();

        step3RegistrationStore.loadActiveInsurancePolicy().then(policies => {
          const service = this.getProductForActiveInsurancePolicy(policies)
          if (service) {
            this.onSelectServiceHandler(service.id);
            policyStartDate = policies.attributes.start_date;
            step3RegistrationStore.setFormField('product.startDate', moment(policyStartDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ'));
            this.setFieldsValue();
            this.setState({ hasAlreadyService: true });
            return;
          }

          if (step3RegistrationStore.services && step3RegistrationStore.services[0] && step3RegistrationStore.services[0].id) {
            this.onSelectServiceHandler(step3RegistrationStore.services[0].id);
          }
        });

      }
    );

    this.setState({ componentDidMount: true });

    step3RegistrationStore.setFormField('product.signaturePlace', profileStore.profile.city);
    step3RegistrationStore.setFormField('product.signatureDate', installationSignatureDate ? moment(installationSignatureDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ') : moment());
    step3RegistrationStore.setFormField('product.startDate', startDate ? moment(startDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ') : moment());

    if (step3RegistrationStore.externalPayments().length > 0) {
      step3RegistrationStore.setFormField('product.externalPayment', step3RegistrationStore.externalPayments()[0].pageId);
    }

    if (zuoraOneTimeRatePlan) {
      let serviceId = zuoraOneTimeRatePlan.id;
      if (zuoraRecurringRatePlan) {
        serviceId = `${serviceId}_${zuoraRecurringRatePlan.id}`;
        zuoraOneTimeRatePlan.paymentType && step3RegistrationStore.setFormField('product.paymentType', zuoraRecurringRatePlan.paymentType.pageId);
        if (zuoraOneTimeRatePlan.paymentType.pageId !== zuoraRecurringRatePlan.paymentType.pageId) {
          step3RegistrationStore.setFormField('product.paymentExceptionForActivation', true);
          zuoraOneTimeRatePlan.paymentType && step3RegistrationStore.setFormField('product.externalPayment', zuoraOneTimeRatePlan.paymentType.pageId);
        }
      } else {
        zuoraOneTimeRatePlan.paymentType && step3RegistrationStore.setFormField('product.paymentType', zuoraOneTimeRatePlan.paymentType.pageId);
      }
      step3RegistrationStore.setFormField('product.serviceId', serviceId);
      this.setState({ paymentMethods: step3RegistrationStore.allowedPaymentMethodsByServiceId(serviceId) });
    }

    if (this.props.registrationStore.heartbeat.status === 1 && !startDate) {
      this.props.step3RegistrationStore.setFormField('product.startDate', moment());
    }

    this.setFieldsValue();
  }

  setFieldsValue() {
    this.props.form.setFieldsValue(this.props.step3RegistrationStore.formValues.product);
  }

  onSelectServiceHandler = serviceId => {
    this.clearAdditionalDevices();
    const { step3RegistrationStore } = this.props;
    step3RegistrationStore.setFormField('product.serviceId', serviceId);
    const product = step3RegistrationStore.services.find(s => s.id === serviceId);

    step3RegistrationStore.setFormField('product.id', product.productId);
    step3RegistrationStore.setFormField('product.recurringProduct', (product.recurring || {}).ratePlanId);
    this.setState({ recurring: product.recurring });
    this.setFieldsValue();
    return new Promise(resolve => {
      this.setState({ paymentMethods: step3RegistrationStore.allowedPaymentMethodsByServiceId(serviceId) }, () => {
        resolve(this.state.paymentMethods);
        if (this.state.paymentMethods.length === 0) return;
        if (this.state.paymentMethods.findIndex(payment => payment.pageId === 'other') < 0) {
          this.onSelectPaymentHandler(this.state.paymentMethods[0].pageId);
        } else {
          this.onSelectPaymentHandler(this.state.paymentMethods.find(payment => payment.pageId === 'other').pageId);
        }
      });
    });
  };

  onSelectPaymentHandler = pageId => {
    this.props.step3RegistrationStore.setFormField('product.paymentType', pageId);
    this.setFieldsValue();
  };

  onClickPaymentCheckHandler = e => {
    this.props.step3RegistrationStore.setFormField('product.paymentExceptionForActivation', e.target.checked);
    this.setFieldsValue();
  };

  onChangeStartDateHandler = startDate => {
    this.props.step3RegistrationStore.setFormField('product.startDate', startDate);
    this.setFieldsValue();
  };

  onEditAuthorizedAssistanceCenter = () => {
    const {
      step3RegistrationStore,
      step3RegistrationStore: { user },
      profileStore,
    } = this.props;

    const { profile } = profileStore;
    const { installerInformation = {} } = user.assets[0].subscription;

    const isCancellingEdit = this.state.isEditAuthorizedAssistanceCenterVisible;

    this.setState(prevState => ({isEditAuthorizedAssistanceCenterVisible: !prevState.isEditAuthorizedAssistanceCenterVisible}), () => {

      if (isCancellingEdit) {

        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter', undefined);
      } else {

        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.ragsoc', installerInformation.ragsoc ? installerInformation.ragsoc : profile.ragsoc);
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.phone', installerInformation.phone ? installerInformation.phone : profile.phone);
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.country', countriesHelper.getCountryCodeFromName(installerInformation.country ? installerInformation.country : profile.country) || 'IT');
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.prov', installerInformation.prov ? installerInformation.prov : profile.prov);
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.city', installerInformation.city ? installerInformation.city : profile.city);
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.postcode', installerInformation.postcode ? installerInformation.postcode : profile.postcode);
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.address', installerInformation.address ? installerInformation.address : profile.address);
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.number', installerInformation.number ? installerInformation.number : profile.number);
        step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.technicalName', installerInformation.ragsoc ? installerInformation.ragsoc : profile.ragsoc);
      }

      this.setFieldsValue();
    });
  };

  requiredRule = label => {
    return {
      required: true,
      message: `The field [${label}] is required`
    };
  };

  handlerOnChange = field => e => {
    const value = typeof e === 'string' ? e : e.target.value;
    this.props.step3RegistrationStore.setFormField(field, value);
    if (field === 'product.authorizedAssistanceCenter.country') {
      this.props.step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.prov', '');
      this.props.step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.city', '');
    }
    if (field === 'product.authorizedAssistanceCenter.prov') {
      this.props.step3RegistrationStore.setFormField('product.authorizedAssistanceCenter.city', '');
    }

    this.setFieldsValue();
  };

  ProductSelectionTabPaneSelectCountries = (label, { onChange = this.handlerOnChange('product.authorizedAssistanceCenter.country'), placeholder }) => {
    const { countriesList: countries } = this.props.countriesStore;
    return this.props.WithDecorator('authorizedAssistanceCenter.country', label, {
      rules: [this.requiredRule(label)]
    })(<SelectOptions style={{ width: '174px' }} placeholder={placeholder || label} onChange={onChange} options={countries.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))} />);
  };

  Step_3SelectProvinces = (label, { onChange = this.handlerOnChange('product.authorizedAssistanceCenter.prov'), placeholder, disabled = this.props.step3RegistrationStore.inProgress }) => {
    const { provincesList: provinces } = this.props.provincesStore;
    return this.props.WithDecorator('authorizedAssistanceCenter.prov', label, {
      rules: [this.requiredRule(label)]
    })(<SelectOptions style={{ width: '174px' }} placeholder={placeholder || label} onChange={onChange} disabled={disabled} options={provinces.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))} />);
  };

  Step_3SelectCities = (label, { onChange = this.handlerOnChange('product.authorizedAssistanceCenter.city'), placeholder, disabled = this.props.step3RegistrationStore.inProgress }) => {
    const { citiesList: cities } = this.props.citiesStore;
    return this.props.WithDecorator('authorizedAssistanceCenter.city', label, {
      rules: [this.requiredRule(label)]
    })(<SelectOptions style={{ width: '174px' }} placeholder={placeholder || label} onChange={onChange} disabled={disabled} options={(this.props.form.getFieldValue('authorizedAssistanceCenter.country')==='IT' && this.props.form.getFieldValue('authorizedAssistanceCenter.prov') !== undefined) ? cities.filter(city => city.prov_code === this.props.form.getFieldValue('authorizedAssistanceCenter.prov')).sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0)) : []} />);
  };

  Step_3ProductRequiredBasicInputField = (name, label, { onChange = this.handlerOnChange(`product.${name}`), placeholder, type, disabled = this.props.step3RegistrationStore.inProgress, rules = [] }) =>
    this.Step_3ProductBasicInputField(name, label, {
      onChange,
      placeholder,
      type,
      disabled,
      rules: [this.requiredRule(label), ...rules]
    });

  Step_3ProductBasicInputField = (name, label, { onChange = this.handlerOnChange(`product.${name}`), placeholder, type, disabled = this.props.step3RegistrationStore.inProgress, rules = [] }) =>
    this.props.WithDecorator(name, label, {
      rules: [...rules]
    })(<Input type={type || 'text'} placeholder={placeholder || label} onChange={onChange} disabled={disabled} />);

  onChangeSignaturePlaceHandler = e => {
    this.props.step3RegistrationStore.setFormField('product.signaturePlace', e.target.value);
    this.setFieldsValue();
  };

  onChangeSignatureDateHandler = signatureDate => {
    this.props.step3RegistrationStore.setFormField('product.signatureDate', signatureDate);
    this.setFieldsValue();
  };

  isCheckboxPaymentExceptionVisible = () => {
    const {
      step3RegistrationStore,
      form: { getFieldValue }
    } = this.props;
    return (
      getFieldValue('serviceId') &&
      step3RegistrationStore.services.findIndex(s => s.id === getFieldValue('serviceId') && (!!s.recurring && s.hasOwnProperty('oneTime'))) > -1 &&
      step3RegistrationStore.externalPayments().length > 0
    );
  };

  showExternalPayments = () => this.isCheckboxPaymentExceptionVisible();

  getExternalPaymentsLabels = () => {
    return this.props.step3RegistrationStore
      .externalPayments()
      .map(p => p.pageName)
      .reduce((acc, current) => (acc ? `${acc} - ${current}` : current), null);
  };

  changeExternalPayment = e => {
    this.props.step3RegistrationStore.setFormField('product.externalPayment', e.target.value);
    this.setFieldsValue();
  };

  onChangeSignatureMethod = e => {
    this.props.step3RegistrationStore.setFormField('product.signatureMethod', e.target.value);
    this.setFieldsValue();
  };

  isServiceWithAdditionalDevicesInstallation = () => {
    const {
      step3RegistrationStore,
      form: { getFieldValue }
    } = this.props;
    const deviceTypesHavingAdditionalInstallations = ['primary + ghost'];
    return (
        getFieldValue('serviceId') &&
        step3RegistrationStore.services.findIndex(s => s.id === getFieldValue('serviceId') && (s.hasOwnProperty('oneTime')) && (s.oneTime.hasOwnProperty('deviceType')) && deviceTypesHavingAdditionalInstallations.includes(s.oneTime.deviceType)) > -1
    );
  };

  // onSelectAdditionalDevicesHandler = additionalDevices => {
  //   this.props.step3RegistrationStore.setFormField('product.additionalDevices', additionalDevices);
  //   this.setFieldsValue();
  // };

  clearAdditionalDevices = additionalDevices => {
    this.props.step3RegistrationStore.setFormField('product.additionalDevices', undefined);
    this.setFieldsValue();
  };

  render() {
    const { selectedAdditionalDevices } = this.state;
    const uploadDocument = (props, uploadText = <div>{t['shared']['lblDragFileToArea']}</div>) => (
      <Upload.Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">{uploadText}</p>
      </Upload.Dragger>
    );

    const {
      step3RegistrationStore,
      translationsStore: { current: t },
      profileStore,
    } = this.props;

    const { installerInformation = {} } = step3RegistrationStore.user.assets[0].subscription;

    const { additionalDeviceInstallation, additionalAssets: additionalAssetsPool = [] } = profileStore.profile;
    const manageAdditionalDevices = this.isServiceWithAdditionalDevicesInstallation();

    return (
      <Form name="product">
        <Layout>
          <Content className="productFormContent">
            <Col md={{ span: 20 }}>
              <Col className="productIdSelector">{this.props.WithDecorator('id', '', {}, {})(<Input type="hidden" name="productId" />)}</Col>
              <Col className="serviceIdSelector">
                {this.props.RequiredWithDecorator('serviceId', t['shared']['lblServiceName'], {}, {})(
                  <SelectOptions
                    disabled={step3RegistrationStore.services.length === 0 || step3RegistrationStore.inProgress || this.state.hasAlreadyService}
                    name="service"
                    options={step3RegistrationStore.services}
                    optionValue="id"
                    optionContent={(option, index) => `(${option.productName}) ${['oneTime', 'recurring'].filter(x => option[x]).map(x => option[x].name).join(', ')}`}
                    optionTitle="description"
                    onChange={this.onSelectServiceHandler}
                  />
                )}
              </Col>
              {this.isCheckboxPaymentExceptionVisible() && (
                <Col className="paymentExceptionForActivation">
                  {this.props.WithDecorator('paymentExceptionForActivation', t['shared']['lblActivatioFeeUpfront'], { valuePropName: 'checked' }, {})(
                    <Checkbox disabled={step3RegistrationStore.inProgress} onChange={this.onClickPaymentCheckHandler} />
                  )}
                </Col>
              )}
              {!this.isCheckboxPaymentExceptionVisible() && this.props.WithDecorator('paymentExceptionForActivation', '', {}, {})(<Input type="hidden" name="productId" />)}
              {this.showExternalPayments() && (
                <Col className="externalPayments">
                  {this.props.WithDecorator('externalPayment', '', {}, {})(
                    <Radio.Group disabled={!this.props.form.getFieldValue('paymentExceptionForActivation')} onChange={this.changeExternalPayment}>
                      {step3RegistrationStore.externalPayments().map(p => {
                        return (
                          <Radio key={`ep_${p.pageId}`} value={p.pageId}>
                            {p.pageName}
                          </Radio>
                        );
                      })}
                    </Radio.Group>
                  )}
                </Col>
              )}
              {!this.showExternalPayments() && this.props.WithDecorator('externalPayment', '', {}, {})(<Input type="hidden" />)}
              {this.props.WithDecorator('recurringProduct', '', {}, {})(<Input type="hidden" />)}
              <Col>
                {this.props.RequiredWithDecorator('paymentType', t['shared']['lblTermsOfPaymemt'], {}, {})(
                  <SelectOptions
                    placeholder={t['shared']['lblTermsOfPaymemt']}
                    disabled={this.state.paymentMethods.length === 0 || step3RegistrationStore.inProgress}
                    options={this.state.paymentMethods}
                    optionValue="pageId"
                    optionContent="pageName"
                    name="payment"
                    onChange={this.onSelectPaymentHandler}
                  />
                )}
              </Col>
              <Col>
                {this.props.RequiredWithDecorator('startDate', t['shared']['lblDecurringDate'], {}, {})(
                  <DatePicker
                    disabled={step3RegistrationStore.inProgress || this.state.hasAlreadyService}
                    format={this.props.translationsStore.longDateFormat.L}
                    placeholder={t['shared']['lblDecurringDate']}
                    onChange={this.onChangeStartDateHandler}
                  />
                )}
              </Col>
            </Col>
            {manageAdditionalDevices && <Fragment>
              {(Array.from(Array(additionalDeviceInstallation).keys())).map((ad, index) => {
                const localAdditionalAssets = additionalAssetsPool.filter(aa => !selectedAdditionalDevices.map(x => x.value).includes(aa.imei))
                let label = `Additional device #${index+1}`;
                return <Row key={index}>
                  <Col>
                    {this.props.RequiredWithDecorator(`additionalDevices${index}`, label, {
                    }, {})(
                      <SelectOptions
                        placeholder={t['registration_3']['lblAdditionalDevices']}
                        options={localAdditionalAssets}
                        optionValue="imei"
                        optionContent="imei"
                        name={`additionalDevices${index}`}
                        onChange={(additionalDevices) => {
                          this.props.step3RegistrationStore.setFormField(`product.additionalDevices${index}`, additionalDevices);
                          this.setState(prevState => {
                            let { selectedAdditionalDevices } = prevState;
                            const value = additionalDevices;
                            const selectedIndex = selectedAdditionalDevices.findIndex(sad => sad.index === index);
                            if (selectedIndex === -1) {
                              selectedAdditionalDevices =[...selectedAdditionalDevices, { index, value: additionalDevices }];
                            } else {
                              selectedAdditionalDevices[selectedIndex] = { index, value };
                            }
                            return { selectedAdditionalDevices };
                          }, () => {
                            this.props.step3RegistrationStore.selectedAdditionalDevices = this.state.selectedAdditionalDevices.map(x => x.value);
                          });
                          this.setFieldsValue();
                        }}
                      />
                    )}
                  </Col>
                </Row>
              })}
            </Fragment>}
          </Content>
          <Divider/>
          <Footer>
            <Row>
              {t['shared']['lblDetailsOfAssistanceCenter']}
              &nbsp;&nbsp;&nbsp;
              <Button
                type="primary"
                onClick={this.onEditAuthorizedAssistanceCenter.bind(this)}
              >
                {t['registration_3']['detailsOfAssistanceCenter'][this.state.isEditAuthorizedAssistanceCenterVisible ? 'lblCancelEditDetailsOfAssistanceCenter' : 'lblEditDetailsOfAssistanceCenter']}
              </Button>
              {!this.state.isEditAuthorizedAssistanceCenterVisible && <Input value={installerInformation.ragsoc ? installerInformation.ragsoc : profileStore.profile.ragsoc} readOnly style={{marginTop: '10px'}}/>}
            </Row>
            {this.state.isEditAuthorizedAssistanceCenterVisible && <Fragment>
              <Row>
                {this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.ragsoc', t['shared']['lblCompanyName'], {})}
              </Row>
              <Row type="flex" style={{ flexWrap: 'wrap' }} justify="start">
                <Col style={{ flex: 'auto', marginRight: '15px' }}>
                  {this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.technicalName', t['shared']['lblTechnicalOperatorName'], {})}
                </Col>
                <Col>
                  {this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.phone', t['shared']['lblPhone'], {})}
                </Col>
              </Row>
              <Row type="flex" align="space-between">
                <Col style={{ flex: 'auto', marginRight: '15px' }}>
                  {this.ProductSelectionTabPaneSelectCountries(t['shared']['lblCountry'], {})}
                </Col>
                <Col style={{ flex: 'auto', marginRight: '15px' }}>
                  {(this.props.form.getFieldValue('authorizedAssistanceCenter.country') === 'IT') ? (
                    this.Step_3SelectProvinces(t['shared']['lblProv'], {})
                  ) : (
                    this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.prov', t['shared']['lblProv'], {})
                  )}
                </Col>
                <Col style={{ flex: 'auto', marginRight: '15px' }}>
                  {(this.props.form.getFieldValue('authorizedAssistanceCenter.country') === 'IT') ? (
                    this.Step_3SelectCities(t['shared']['lblCity'], {})
                  ) : (
                    this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.city', t['shared']['lblCity'], {})
                  )}
                </Col>
              </Row>
              <Row type="flex" style={{ flexWrap: 'wrap' }} justify="start">
                <Col style={{ flex: '3', marginRight: '15px' }}>
                  {this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.address', t['shared']['lblAddress'], {})}
                </Col>
                <Col style={{ flex: '1', marginRight: '15px' }}>
                  {this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.number', t['shared']['lblAddressNumber'], {})}
                </Col>
                <Col style={{ flex: '1' }}>
                  {this.Step_3ProductRequiredBasicInputField('authorizedAssistanceCenter.postcode', t['shared']['lblPostcode'], {
                    rules: [
                      {
                        type: 'string',
                        pattern: REGEX_POSTALCODE,
                        message: `The field is not a valid cap`
                      }
                    ]
                  })}
                </Col>
              </Row>
            </Fragment>}
            <Divider/>
            <Row type="flex" align="space-between">
              <Col style={{ flex: 'auto', marginRight: '15px' }}>
                {this.props.RequiredWithDecorator('signaturePlace', t['shared']['lblSignaturePlace'], {})(
                  <Input readOnly placeholder={t['shared']['lblSignaturePlace']} onChange={this.onChangeSignaturePlaceHandler} />
                )}
              </Col>
              <Col>
                {this.props.RequiredWithDecorator('signatureDate', t['shared']['lblSignatureDate'], {})(
                  <DatePicker
                    disabled={step3RegistrationStore.inProgress}
                    placeholder={t['shared']['lblSignatureDate']}
                    format={this.props.translationsStore.longDateFormat.L}
                    onChange={this.onChangeSignatureDateHandler}
                  />
                )}
              </Col>
            </Row>

            {process.env.REACT_APP_ENV !== 'production' && (
              // <Divider style={{ marginBottom: '0' }} />
              <Row className="signatureMethod">
                {this.props.RequiredWithDecorator('signatureMethod', t['shared']['lblSignatureMethod'], {})(
                  <Radio.Group onChange={this.onChangeSignatureMethod}>
                    <Radio value={'digital'}>Digital</Radio>
                    <Radio value={'classic'}>Classic</Radio>
                  </Radio.Group>
                )}
                {step3RegistrationStore.formValues.product.signatureMethod === 'digital' && (
                  <div className="digitalUpload">
                    {uploadDocument(
                      this.uploadProps(),
                      <span>
                        {t['shared']['lblDragFileToArea']} <strong>{t['registration_3']['lblPersonalDocument']}</strong>
                      </span>
                    )}
                  </div>
                )}
              </Row>
            )}
          </Footer>
        </Layout>
      </Form>
    );
  }
}
export default Form.create()(airForm(ProductSelectionTabPane));



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/ProductSelectionTabPane.js